import * as yup from 'yup';
import * as _ from 'lodash';
import { useFormik } from 'formik';
import ReactQuill from 'react-quill';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { useEffect, useState } from 'react';
import { SERVER_URL } from '../../../constants';
import * as actions from '../../../redux/actions';
import { TextField } from '../../common/FormFields';
import * as selectors from '../../../redux/selectors';
import PageContainer from '../../common/PageContainer';
import { newsAlertStyleOptions } from '../email.constants';
import { DateInput, TimeInput } from 'semantic-ui-calendar-react';
import * as api from './../../../api/campaignApi';

import {
  Breadcrumb,
  Button,
  Container,
  Dropdown,
  Form,
  Grid,
  Image,
  Label,
  Menu,
  Message,
  Popup,
  Segment,
} from 'semantic-ui-react';
import MailChimpSection from '../MailChimpSection';
import toast from 'react-hot-toast';
import SearchPostsDetail from '../SearchPostsDetail';
import * as $ from 'jquery';

const NewsAlert = ({
  sites,
  getSites,
  loading,
  setLoading,
  history,
  clearRecentPosts,
  topPostResults,
  match,
  user,
  findTemplate,
}) => {
  const id = match.params.id;

  const [newsAlert, setNewsAlert] = useState(null);

  const validationSchema = yup.object({
    style: yup.string().required('You must select a style'),
    siteId: yup.string().required('You must select a site').nullable(),
    subject: yup
      .string()
      .max(50, 'Subject must be at most 50 characters.')
      .required('A subject is required')
      .nullable(),
    title: yup.string().nullable(),
    photoUrl: yup.string().optional('You must provide a photo.').nullable(),
    buttonLabel: yup.string().optional('You must provide a button label.').nullable(),
    buttonUrl: yup.string().optional('You must provide a button URL.').nullable(),
    body: yup.string().nullable(),
  });

  const isValid = () => {
    try {
      validationSchema.validateSync(formik.values);
      return true;
    } catch (e) {
      return false;
    }
  };

  const UTM_MAP = {
    null: 'news-alert',
    undefined: 'news-alert',
    'News Alert': 'news-alert',
  };

  const getUtm = style => `utm_source=${UTM_MAP[style]}&utm_medium=email&utm_campaign=website`;

  const errorStyle = { color: '#9f3a38', border: '1px solid #e0b4b4!important' };

  const initialValues = {
    style: 'News Alert',
    subject: '',
    title: '',
    photoUrl: '',
    emailTemplateId: '',
    teaser: '',
    buttonLabel: '',
    buttonUrl: '',
    body: '',
    newsItems: [],
    newsLinks: [],
    trendingEvents: [],
    trendingPlaces: [],
    siteId: '',
    startDate: '',
    endDate: '',
    sendDate: '',
    sendTime: '',
    photoType: 'Photograph (wide crop)',
    utm: getUtm(newsAlert?.style),
  };

  const handleSubmit = (digest, formik) => {
    const data = {
      ...digest,
    };

    api.updateNewsAlert(data).then(() => {
      toast.success('News Alert updated successfully!');
      formik.setSubmitting(false);
    });
  };

  const formik = useFormik({
    enableReinitialize: true,
    onSubmit: handleSubmit,
    initialValues,
    validationSchema,
    validateOnChange: false,
    validateOnBlur: false,
  });

  useEffect(() => {
    if (!id) return;
    api.getNewsAlertById(id).then(setNewsAlert);
  }, [id]);

  useEffect(
    () => formik.setValues({ ...newsAlert }),

    [newsAlert]
  );

  useEffect(() => {
    clearRecentPosts();
    formik.resetForm();
  }, []);

  useEffect(() => {
    if (!loading && id) return;
    setLoading(false);
    formik.setFieldValue('trendingNews', _.chain(topPostResults).take(3).value());
  }, [topPostResults]);

  useEffect(() => {
    formik.setFieldValue('utm', getUtm(formik.values.style));

    if (formik.values.title?.length > 60) {
      let title = formik.values.title.substring(0, 60);
      formik.setFieldValue('title', title);
    }

    if (formik.values.style && formik.values.siteId) {
      const template = findTemplate(formik.values.siteId, formik.values.style);
      if (template) {
        formik.setFieldValue('emailTemplateId', template.id);
      }
    }
  }, [formik.values]);

  const getPage = () => (
    <PageContainer>
      <Breadcrumb>
        <Breadcrumb.Section>
          <Link to="/news-alert">News Alerts</Link>
        </Breadcrumb.Section>
        <Breadcrumb.Divider icon="right angle" />
        <Breadcrumb.Section>Add News Alert</Breadcrumb.Section>
      </Breadcrumb>

      <Menu borderless attached="top">
        <Menu.Item header>Add News Alert</Menu.Item>
      </Menu>

      <Segment attached>
        <Form onSubmit={formik.handleSubmit} widths="equal" size="tiny">
          <Grid>
            <Grid.Column width="8">
              <Form.Field error={Boolean(formik.errors.style)}>
                <label htmlFor="style">Style</label>
                <Dropdown
                  fluid
                  search
                  selection
                  clearable
                  options={newsAlertStyleOptions}
                  id="style"
                  data-testid="style"
                  label="Style"
                  name="style"
                  error={Boolean(formik.errors.style)}
                  value={formik.values.style || ''}
                  onChange={(e, d) => formik.setFieldValue(d.name, d.value)}
                />

                {formik.errors.style && <Label basic style={errorStyle} pointing content={formik.errors.style} />}
              </Form.Field>

              <Form.Field error={Boolean(formik.errors.siteId)}>
                <label htmlFor="siteId">City</label>
                {(formik.values.siteId, formik.errors.siteId)}
                <Dropdown
                  fluid
                  search
                  selection
                  clearable
                  options={sites || []}
                  id="siteId"
                  label="City"
                  placeholder="City"
                  name="siteId"
                  value={formik.values.siteId || ''}
                  error={Boolean(formik.errors.siteId)}
                  onChange={(e, d) => formik.setFieldValue('siteId', d.value)}
                />
                {formik.errors.siteId && <Label basic style={errorStyle} pointing content={formik.errors.siteId} />}
              </Form.Field>

              <Form.Field>
                <TextField
                  name="subject"
                  formik={formik}
                  value={formik.values.subject || ''}
                  onChange={e => {
                    if (e?.target?.value) {
                      e.target.value = $($.parseHTML(e.target.value)).text().substring(0, 60);
                    }
                    formik.handleChange(e);
                  }}
                  error={Boolean(formik.errors.subject)}
                  errorMessage={formik.errors.subject}
                  label={`Subject line (Characters: ${formik.values?.subject?.length || 0})`}
                />
              </Form.Field>
              <Form.Field>
                <TextField
                  name="title"
                  formik={formik}
                  value={formik.values.title || ''}
                  onChange={formik.handleChange}
                  error={Boolean(formik.errors.title)}
                  errorMessage={formik.errors.title}
                  label={`Title (Characters: ${formik?.values?.title?.length || 0})`}
                />
              </Form.Field>

              <Grid style={{ padding: `1rem` }}>
                <strong style={{ marginLeft: -15 }}>Photo</strong>

                {formik?.values?.photoUrl && (
                  <Grid.Row>
                    <Image
                      src={formik.values.photoUrl}
                      size="medium"
                      as="a"
                      href={formik.values.photoUrl}
                      rel="noreferrer"
                      target="_blank"
                    />
                  </Grid.Row>
                )}

                <Grid.Row>
                  <Form.Field>
                    <SearchPostsDetail
                      siteId={formik.values.siteId}
                      handleSelection={async post => {
                        console.log({ post });
                        formik.setFieldValue('photoUrl', post.image_url);
                        formik.setFieldValue('buttonUrl', post.post_url);
                        formik.setFieldValue('title', post.headline?.substring(0, 60));
                        formik.setFieldValue('body', post.description);
                      }}
                      contentType={'page,image,video,article'}
                      site={formik.values.siteId}
                      trigger={<Button icon="search" type="button" labelPosition="left" content="Set Post" />}
                    />
                    {formik.errors.photoUrl && (
                      <Label basic style={errorStyle} pointing content={formik.errors.photoUrl} />
                    )}
                  </Form.Field>
                </Grid.Row>
              </Grid>

              {/* <Form.Field error={Boolean(formik.errors.photoType)}>
                <label htmlFor="style">Photo type</label>
                <Dropdown
                  fluid
                  search
                  selection
                  clearable
                  options={['Photograph (wide crop)', 'Standard marketing image'].map(item => ({
                    text: item,
                    value: item,
                    key: item,
                  }))}
                  id="photoType"
                  data-testid="photoType"
                  name="photoType"
                  error={Boolean(formik.errors.photoType)}
                  value={formik.values.photoType || ''}
                  onChange={(e, d) => formik.setFieldValue(d.name, d.value)}
                />

                {formik.errors.style && <Label basic style={errorStyle} pointing content={formik.errors.style} />}
              </Form.Field> */}

              <Form.Field>
                <TextField
                  name="buttonLabel"
                  formik={formik}
                  value={formik.values.buttonLabel || ''}
                  onChange={formik.handleChange}
                  error={Boolean(formik.errors.buttonLabel)}
                  errorMessage={formik.errors.buttonLabel}
                  label={`Button label`}
                />
              </Form.Field>
              <Form.Field>
                <TextField
                  name="buttonUrl"
                  formik={formik}
                  value={formik.values.buttonUrl || ''}
                  onChange={formik.handleChange}
                  error={Boolean(formik.errors.buttonUrl)}
                  errorMessage={formik.errors.buttonUrl}
                  label={`Button URL`}
                />
              </Form.Field>

              <Form.Field error={Boolean(formik.errors.body)}>
                <label>Body</label>
                <ReactQuill
                  theme="snow"
                  value={formik.values.body || ''}
                  onChange={(e, { value }) => formik.setFieldValue('body', e)}
                  style={{ height: 300 }}
                />
                {formik.errors.body && <Message negative size="small" content={formik.errors.body} />}
              </Form.Field>

              <br />
              <br />

              <Form.Field>
                <TextField
                  name="teaser"
                  formik={formik}
                  value={formik.values.teaser || ''}
                  onChange={formik.handleChange}
                  error={Boolean(formik.errors.teaser)}
                  errorMessage={formik.errors.teaser}
                  label={`Teaser`}
                />
              </Form.Field>

              <Form.Field>
                <label>Send date</label>
                <DateInput
                  closable={true}
                  name="sendDate"
                  popupPosition="bottom center"
                  placeholder="Send date"
                  value={formik.values.sendDate || ''}
                  iconPosition="left"
                  dateFormat="YYYY-MM-DD"
                  onChange={(e, { value }) => formik.setFieldValue('sendDate', value)}
                />
              </Form.Field>
              <Form.Field>
                <label>Send time</label>
                <TimeInput
                  name="sendTime"
                  placeholder="Send time"
                  value={formik.values.sendTime || ''}
                  iconPosition="left"
                  onChange={(e, { value }) => formik.setFieldValue('sendTime', value)}
                />
              </Form.Field>
            </Grid.Column>
          </Grid>
        </Form>
        <br />
        <br />
      </Segment>

      <Container fluid style={{ marginTop: 10 }}>
        <Button
          positive
          content="Save"
          onClick={() => {
            formik.validateForm().then(err => {
              if (err && Object.keys(err).length > 0) {
                toast.error('Please fix errors before saving');
              } else {
                formik.submitForm();
                setTimeout(() => history.push('/news-alert'), 2000);
              }
            });
          }}
        />

        <Button
          positive
          content="Save as new"
          onClick={async () => {
            const { id, site, emailTemplate, __typename, ...data } = formik.values;
            if (id) {
              const post = await api.addNewsAlert(data);
              history.push(`/news-alert/edit/${post?.id}`);
            }
          }}
        />

        <Button
          positive
          content="Save and continue editing"
          onClick={() => {
            formik.validateForm().then(err => {
              console.log({ err });
              if (err && Object.keys(err).length > 0) {
                toast.error('Please fix errors before saving');
              } else {
                formik.submitForm();
              }
            });
          }}
        />

        <Button
          icon="envelope"
          content="Send Test Email"
          disabled={!isValid()}
          onClick={async () => {
            setLoading(true, 'Sending test email...');
            await api.sendNewsAlertTestEmail(formik.values.id).then(() => setLoading(false));
            toast.success('Test email sent');
          }}
        />

        <Button
          icon="envelope"
          disabled={!isValid()}
          content="Schedule Email"
          onClick={() => {
            formik.setFieldValue('isScheduled', true);
            formik.validateForm().then(err => {
              if (err && Object.keys(err).length > 0) {
                toast.error('Please fix errors before saving');
              } else {
                formik.submitForm();
              }
            });
          }}
        />

        <Button
          icon="binoculars"
          content="Preview"
          target="_blank"
          labelPosition="left"
          disabled={!isValid()}
          href={`${SERVER_URL}/api/news-alert/email/${formik.values.id}`}
        />

        <Popup
          closeOnPortalMouseLeave
          trigger={<Button icon="trash" negative content="Delete" floated="right" />}
          content={
            <Button
              color="green"
              content="Are you sure?"
              onClick={() =>
                api.deleteNewsAlert(id).then(() => {
                  toast.success('News Alert deleted');
                  history.push('/news-alert');
                })
              }
            />
          }
          on="click"
          position="bottom left"
        />
      </Container>

      <br />
      <MailChimpSection id={id} user={user} formik={formik} />
    </PageContainer>
  );

  return id ? <>{newsAlert?.id && getPage()}</> : <>{getPage()}</>;
};

const mapStateToProps = state => ({
  firm: selectors.getCurrentFirm(state),
  cities: selectors.getCityOptions(state),
  sites: selectors.getSiteOptions(state),
  topPostResults: selectors.getTopPosts(state),
  searchPostResults: selectors.getSearchPosts(state),
  user: selectors.users.current(state),
  dayOptions: selectors.getDayOptions(state),
  findTemplate: selectors.templates.find(state),
  loading: selectors.users.loading,
});

const mapDispatchToProps = dispatch => ({
  clearRecentPosts: bindActionCreators(actions.campaign.clearRecentPosts, dispatch),
  getTopPosts: bindActionCreators(actions.campaign.getTopPosts, dispatch),
  searchPosts: bindActionCreators(actions.campaign.searchDigests, dispatch),
  getSites: bindActionCreators(actions.admin.getSites, dispatch),
  setLoading: bindActionCreators(actions.user.setLoading, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewsAlert);
